import React, { useState, useEffect, Suspense, lazy } from "react";
import { Modal, Spin, message } from "antd";
import ApiService from "../Components/apiService";
import { BASE_URL } from "../Components/Constant";
import eventBus from '../Components/eventBus'; // Already imported

const ShowComponentModal = ({
  objName,
  recId,
  componentName,
  showComponentInModal,
  setShowComponentInModal
}) => {
  const [DynamicComponent, setDynamicComponent] = useState(null);

  useEffect(() => {
    if (!componentName || componentName.includes("?")) return;
  
    const loadComponent = async () => {
      try {
        const Component = lazy(() =>
          import(`../ModalComponents/${componentName}`)
        );
        setDynamicComponent(() => Component);
      } catch (error) {
        console.error("Error loading component:", error);
        message.error("Component failed to load.");
      }
    };
  
    loadComponent();
  }, [componentName]);
  

  // const fetchFileAndDownload = async ({
  //   record_id,
  //   primary_object,
  //   template_id,
  //   attached,
  //   download
  // }) => {
  //   console.log('inside the fetchFileAndDownload');
  //   try {
  //     eventBus.emit("loadingStart", "File is being downloaded, hold on...");

  //     const apiService = new ApiService(
  //       `${BASE_URL}/generate_docx_new/${template_id}/${record_id}/${primary_object}`,
  //       { "Content-Type": "application/json" },
  //       "POST"
  //     );

  //     const response = await apiService.makeCall();
  //     console.log('res for preview file',response);
     

  //     if (response?.base64) {
  //       handleDownloadFile(response);
  //     } else {
  //       message.error("File download failed.");
  //     }
  //   } catch (error) {
  //     console.error("Download error:", error);
  //     message.error("Error downloading file.");
  //   }finally{
  //     eventBus.emit("loadingEnd"); // Emit loading end (always)

  //   }
  // };

  // const handleDownloadFile = (response) => {
  //   const byteCharacters = atob(response?.base64);
  //   const byteNumbers = new Uint8Array(byteCharacters.length);

  //   for (let i = 0; i < byteCharacters.length; i++) {
  //     byteNumbers[i] = byteCharacters.charCodeAt(i);
  //   }

  //   const blob = new Blob([byteNumbers], { type: response.file_type });
  //   const url = window.URL.createObjectURL(blob);
  //   const a = document.createElement("a");
  //   a.href = url;
  //   a.download = response.file_name || "downloaded_file.docx";
  //   document.body.appendChild(a);
  //   a.click();
  //   window.URL.revokeObjectURL(url);
  //   document.body.removeChild(a);

  //   message.success("File downloaded successfully!");
  // };

  return (
    <Modal
      open={showComponentInModal}
      onCancel={() => setShowComponentInModal(false)}
      zIndex={1002}   // higher than sidebar
      footer={null}
    >
      {DynamicComponent ? (
        <Suspense fallback={<Spin size="large" />}>
          <DynamicComponent recId={recId} objName={objName} />
        </Suspense>
      ) : (
        !componentName.includes("?") && <p>Loading...</p>
      )}
    </Modal>
  );
};

export default ShowComponentModal;
